export default {
    subFieldDelimiter: '_',
    emptyValue: '-',
    primitiveProps: ['label', 'validators', 'conditions', 'clearButtonAriaLabel', 'name', 'autocomplete', 'description', 'type', 'maxLength', 'predefinedValue', 'required']
};